import { render, staticRenderFns } from "./RodanSetValues.vue?vue&type=template&id=0c8d894c&scoped=true&"
import script from "./RodanSetValues.vue?vue&type=script&lang=js&"
export * from "./RodanSetValues.vue?vue&type=script&lang=js&"
import style0 from "./RodanSetValues.vue?vue&type=style&index=0&id=0c8d894c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8d894c",
  null
  
)

export default component.exports